import { useEffect, useState } from "react";
import { PageDto } from "../../../types/common";
import { getPageByName } from "../../../api/transport/common";
import { Loader } from "../../../components/Loader";
import { setDocumentTitle } from "../../../utils";

const AcademyAboutClubPage = () => {
    const [pageContent, setPageContent] = useState<PageDto>();

    useEffect(() => {
        getPageByName('club').then(p => {
            setPageContent(p);
            setDocumentTitle(`Об Академии - Официальный сайт Академия «Родина»`);
        })
    }, []);

    if (!pageContent) {
        return <Loader />
    }

    return (
        <div className="max-w-[1024px] mx-auto p-2 pb-6">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">{pageContent.title}</h1>
            <div className="fcr-article fcr-page text-lg" dangerouslySetInnerHTML={{
                __html: pageContent.description
            }} />
        </div>

    );
}

export default AcademyAboutClubPage;